import * as React from "react";
import type { SVGProps } from "react";
const SvgClockWithTimeline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.29 10.71c.2.19.45.29.71.29s.51-.09.71-.29a.996.996 0 0 0 0-1.41L13 8.59V6c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .27.1.52.29.71z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 9c0 3.86 3.14 7 7 7s7-3.14 7-7-3.14-7-7-7-7 3.14-7 7m2 0c0-2.76 2.24-5 5-5s5 2.24 5 5-2.24 5-5 5-5-2.24-5-5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M4 19c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1h2c0 .55.45 1 1 1s1-.45 1-1h2c0 .55.45 1 1 1s1-.45 1-1h2c0 .55.45 1 1 1s1-.45 1-1h2c0 .55.45 1 1 1s1-.45 1-1h1c.55 0 1-.45 1-1s-.45-1-1-1h-1c0-.55-.45-1-1-1s-1 .45-1 1h-2c0-.55-.45-1-1-1s-1 .45-1 1h-2c0-.55-.45-1-1-1s-1 .45-1 1H8c0-.55-.45-1-1-1s-1 .45-1 1z"
    />
  </svg>
);
export default SvgClockWithTimeline;
